<script>
import { useAppStore } from "@/store/modules/app";
import { useCommentsStore } from "@/store/modules/comments";
import { useFormCommentStore } from "@/store/modules/formcomment";
import { mapState, mapWritableState } from 'pinia'
import Editor from 'primevue/editor';
import EmojiPicker from 'vue3-emoji-picker'
import 'vue3-emoji-picker/css'

export default {
  components: {
    EmojiPicker,
    Editor
  },
  data() {
    return {
      componentId: 'form-comment',
      showEmojiPicker: false
    }
  },
  methods: {
    submit() {
      if (this.form.comment || this.form.files.length) {
        const cleanedComment = this.form.comment.replace(/&nbsp;/g, ' ');
        const formData = new FormData();
        formData.append('COMMENT', cleanedComment);
        formData.append('USER_ID', this.userId)
        formData.append('TASK_ID', this.$route.params.id)

        this.form.files.forEach(file => {
          formData.append('FILES[]', file)
        })

        this.$root.postToServer('tasks/comments/add', formData, this.commentPush, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(() => {
          this.$nextTick(() => {
            const lastComment = document.querySelector('.comment:last-child')
            if (lastComment) {
              lastComment.scrollIntoView({behavior: 'smooth'})
            }
          })
        })

        this.form.comment = '';
        this.form.files = [];

        // Очищаем редактор (новый способ для PrimeVue Editor)
        if (this.$refs.editor) {
          this.$refs.editor.$el.querySelector('.ql-editor').innerHTML = '';
        }
      }
    },
    commentPush(resp) {
      const commentExists = this.comments.some(comment => comment.ID === resp.data.result.ID)

      if (!commentExists) {
        this.comments.push(resp.data.result)
        this.lastCommentId = resp.data.result.ID
      }
    },
    onFileChange(e) {
      this.form.files = [...e.target.files]
    },
    addEmoji(emoji) {
      const editor = this.$refs.editor;

      // 1. Пытаемся использовать API Quill (самый надежный способ)
      if (editor) {
        const quill = editor.getQuill?.() ||
            editor.getQuillInstance?.() ||
            editor.$refs?.quill?.quill ||
            editor.$el.__vue__?.quill;

        if (quill) {
          try {
            const range = quill.getSelection();
            const position = range ? range.index : quill.getLength();
            quill.insertText(position, emoji.i);
            quill.setSelection(position + emoji.i.length);
            quill.focus();
            this.showEmojiPicker = false;
            return;
          } catch (e) {
            console.warn("Quill API failed, falling back to DOM method", e);
          }
        }
      }

      // 2. DOM-метод (fallback)
      const editorElement = editor?.$el?.querySelector('.ql-editor');
      if (!editorElement) {
        this.form.comment += emoji.i;
        this.showEmojiPicker = false;
        return;
      }

      // Получаем текущую позицию курсора
      const selection = window.getSelection();
      let cursorPosition = 0;
      let hasValidSelection = false;

      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (editorElement.contains(range.commonAncestorContainer)) {
          //const textContent = editorElement.textContent;
          const preCaretRange = document.createRange();
          preCaretRange.selectNodeContents(editorElement);
          preCaretRange.setEnd(range.endContainer, range.endOffset);
          cursorPosition = preCaretRange.toString().length;
          hasValidSelection = true;
        }
      }

      // Если нет валидного выделения - вставляем в конец
      if (!hasValidSelection) {
        cursorPosition = editorElement.textContent.length;
      }

      // Вставляем эмодзи
      this.insertAtCursorPosition(editorElement, emoji.i, cursorPosition);
      this.showEmojiPicker = false;
    },

// Вспомогательный метод для вставки в позицию курсора
    insertAtCursorPosition(editorElement, emoji, position) {
      const selection = window.getSelection();

      // Создаём временный span для маркировки позиции
      const marker = document.createElement('span');
      marker.id = 'cursor-position-marker';
      marker.style.display = 'none';

      // Находим текстовый узел и позицию
      const textNodes = this.getTextNodes(editorElement);
      let remainingPos = position;
      let targetNode = null;
      let targetOffset = 0;

      for (const node of textNodes) {
        if (remainingPos <= node.length) {
          targetNode = node;
          targetOffset = remainingPos;
          break;
        }
        remainingPos -= node.length;
      }

      // Если не нашли подходящий текстовый узел - добавляем в конец
      if (!targetNode) {
        targetNode = editorElement;
        targetOffset = editorElement.childNodes.length;
      }

      // Вставляем маркер
      const range = document.createRange();
      range.setStart(targetNode, targetOffset);
      range.collapse(true);
      range.insertNode(marker);

      // Вставляем эмодзи перед маркером
      marker.insertAdjacentText('beforebegin', emoji);

      // Удаляем маркер
      marker.remove();

      // Восстанавливаем курсор после эмодзи
      this.$nextTick(() => {
        const newRange = document.createRange();
        const textNodesAfterInsert = this.getTextNodes(editorElement);
        //let newPos = 0;
        let found = false;

        for (const node of textNodesAfterInsert) {
          const text = node.textContent;
          const emojiPos = text.indexOf(emoji);

          if (emojiPos !== -1) {
            newRange.setStart(node, emojiPos + emoji.length);
            newRange.collapse(true);
            found = true;
            break;
          }

          //newPos += text.length;
        }

        if (!found) {
          newRange.selectNodeContents(editorElement);
          newRange.collapse(false);
        }

        selection.removeAllRanges();
        selection.addRange(newRange);
        editorElement.focus();
      });
    },
    // Получение всех текстовых узлов
    getTextNodes(node) {
      const textNodes = [];
      const walker = document.createTreeWalker(
          node,
          NodeFilter.SHOW_TEXT,
          null,
          false
      );

      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      return textNodes;
    },
    removeFile(index) {
      this.form.files.splice(index, 1)
    },
    handleKeyDown(e) {
      // Проверяем комбинацию Ctrl+Enter
      if (e.ctrlKey && e.key === 'Enter') {
        e.preventDefault() // Предотвращаем перенос строки
        this.submit()
      }
      // Просто Enter - разрешаем стандартное поведение (перенос строки)
    }
  },
  computed: {
    ...mapState(useAppStore, ['userId']),
    ...mapWritableState(useCommentsStore, ['comments', 'lastCommentId']),
    ...mapWritableState(useFormCommentStore, ['form'])
  },
  mounted() {
    const formCommentStore = useFormCommentStore()

    this.$watch(
        () => formCommentStore.requestedFocus,
        (newVal) => {
          if (newVal === this.componentId && this.$refs.commentInput) {
            this.$refs.commentInput.focus();
            formCommentStore.clearRequest();
          }
        }
    );
  }
}
</script>

<template>
  <div class="comment-form">
    <!-- Превью прикрепленных файлов -->
    <div v-if="form.files.length" class="file-previews">
      <div v-for="(file, index) in form.files" :key="index" class="file-preview">
        <span>{{ file.name }}</span>
        <button @click="removeFile(index)" class="file-remove-btn">
          &times;
        </button>
      </div>
    </div>

    <form action="" class="footer__toolbar w-100" @submit.prevent="submit">
      <div class="input-wrapper">
        <Editor ref="editor" v-model="form.comment" @keydown="handleKeyDown" />
        <!-- Кнопка добавления эмодзи -->
        <button
            type="button"
            class="emoji-btn"
            @click="showEmojiPicker = !showEmojiPicker"
        >
          😊
        </button>

        <!-- Эмодзи пикер -->
        <div v-if="showEmojiPicker" class="emoji-picker-container">
          <EmojiPicker @select="addEmoji"/>
        </div>
      </div>

      <!-- Кнопка прикрепления файлов -->
      <label class="file-upload-btn">
        <input
            type="file"
            multiple
            @change="onFileChange"
            style="display: none;"
        >
        <svg class="icon icon--middle">
          <use href="img/svgsprite/sprite.symbol.svg#icon-attach"></use>
        </svg>
      </label>

      <div class="send-btn-wrapper">
        <button type="submit" class="footer__toolbar-send-btn">
          <svg class="icon icon--small">
            <use href="img/svgsprite/sprite.symbol.svg#icon-send"></use>
          </svg>
        </button>
        <div class="send-hint">Ctrl+Enter</div>
      </div>
    </form>
  </div>
</template>

<style scoped>
.comment-form {
  position: relative;
  width: 100%;
}

.input-wrapper {
  position: relative;
  flex-grow: 1;
}

.input-wrapper :deep(.p-editor-toolbar) {
  display: none !important;
}

.input-wrapper :deep(.ql-snow) {
  border: 1px solid #d6e4ec !important;
  border-radius: .57rem !important;
}

.input-wrapper :deep(.ql-editor) {
  background: none !important;
  max-height: 200px;
  padding: 0.43rem 2.5rem 0.43rem 0.71rem !important;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.428;
  letter-spacing: .018rem;
}

.emoji-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 0.3rem;
}

.emoji-picker-container {
  position: absolute;
  bottom: 100%;
  right: 0;
  z-index: 1000;
  margin-bottom: 10px;
}

.file-upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.79rem;
  height: 1.79rem;
  cursor: pointer;
  fill: var(--color-primary);
}

.file-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding-bottom: 0.5rem;
}

.file-preview {
  display: flex;
  align-items: center;
  background: #f0f4f8;
  padding: 0.3rem 0.6rem;
  border-radius: 0.3rem;
  font-size: 0.8rem;
}

.file-remove-btn {
  margin-left: 0.5rem;
  background: none;
  border: none;
  color: #ff5252;
  cursor: pointer;
  font-size: 1rem;
  padding: 0 0.2rem;
}

.footer__toolbar {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1.07rem;
}

.footer__toolbar-input {
  padding: 0.43rem 2.5rem 0.43rem 0.71rem !important;
  width: 100%;
  resize: none;
  min-height: 36px;
  max-height: 120px;
  overflow-y: auto;
}

.send-btn-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
}

.footer__toolbar-send-btn {
  width: 1.79rem;
  height: 1.79rem;
  fill: var(--color-primary);
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
}

.send-hint {
  font-size: 0.6rem;
  color: #888;
  line-height: 1;
}
</style>